/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to start OAuth link flow`)
};

const zh_hans1_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法开始 OAuth 绑定流程`)
};

const zh_hant1_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法開始 OAuth 綁定流程`)
};

const fr_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du démarrage du flux de liaison OAuth`)
};

const de_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth-Verknüpfung konnte nicht gestartet werden`)
};

const ja_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 連携フローの開始に失敗しました`)
};

const ko_settings_error_failed_start_oauth_link_flow = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 연결을 시작하지 못했습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_failed_start_oauth_link_flow = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_failed_start_oauth_link_flow(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_failed_start_oauth_link_flow", locale)
	if (locale === "en") return en_settings_error_failed_start_oauth_link_flow(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_failed_start_oauth_link_flow(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_failed_start_oauth_link_flow(inputs)
	if (locale === "fr") return fr_settings_error_failed_start_oauth_link_flow(inputs)
	if (locale === "de") return de_settings_error_failed_start_oauth_link_flow(inputs)
	if (locale === "ja") return ja_settings_error_failed_start_oauth_link_flow(inputs)
	return ko_settings_error_failed_start_oauth_link_flow(inputs)
};